import { useEffect, useState } from "react";
import { useInView } from "react-intersection-observer";

export const useOpacitySlide = ({
    imgList,
    time,
    autoPlay,
}: {
    imgList: Array<any>;
    time: number;
    autoPlay: boolean;
}) => {
    const [currentIdx, setCurrentIdx] = useState(0);
    const [isPlaying, setIsPlaying] = useState(autoPlay);
    const { ref, inView } = useInView({ threshold: 0.9 });
    const nextSlide = () => {
        setCurrentIdx((prev) => (prev === imgList.length - 1 ? 0 : prev + 1));
    };
    const prevSlide = () => {
        setCurrentIdx((prev) => (prev === 0 ? imgList.length - 1 : prev - 1));
    };

    useEffect(() => {
        let interval: NodeJS.Timeout | null = null;

        if (isPlaying && inView) {
            interval = setInterval(() => {
                nextSlide();
            }, time);
        } else if (interval && !inView) {
            clearInterval(interval);
        }

        return () => {
            if (interval) clearInterval(interval);
        };
    }, [isPlaying, nextSlide, prevSlide, inView]);

    const playAuto = () => {
        setIsPlaying(true);
    };
    const stopAuto = () => {
        setIsPlaying(false);
    };

    return { currentIdx, nextSlide, prevSlide, playAuto, stopAuto, isPlaying, ref };
};
